import React, { Component } from 'react';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';

export default class SurveyFrequencyItem extends Component {
    render () {
        return(
            <div className="BSSConditionMain">
                <div className="BSSConditionLabel">{this.props.conditionText}</div>
                <ToggleButtonGroup name={this.props.name} type="radio" value={this.props.value} onChange={this.props.onChangeCallback}>
                    <ToggleButton className="BSSChanceButton" variant="outline-secondary" value={0}>Never</ToggleButton>
                    <ToggleButton className="BSSChanceButton" variant="outline-secondary" value={1}>Rarely</ToggleButton>
                    <ToggleButton className="BSSChanceButton" variant="outline-secondary" value={2}>Sometimes</ToggleButton>
                    <ToggleButton className="BSSChanceButton" variant="outline-secondary" value={3}>Frequently</ToggleButton>
                    <ToggleButton className="BSSChanceButton" variant="outline-secondary" value={4}>Almost Always</ToggleButton>
                </ToggleButtonGroup>
            </div>
        );
    }
}